import { render, staticRenderFns } from "./WidgetsReportDeliveryOrder.vue?vue&type=template&id=4ddea21a&scoped=true"
import script from "./WidgetsReportDeliveryOrder.vue?vue&type=script&lang=js"
export * from "./WidgetsReportDeliveryOrder.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportDeliveryOrder.vue?vue&type=style&index=0&id=4ddea21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddea21a",
  null
  
)

export default component.exports